import { Row } from "antd";
import { withTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { motion } from "framer-motion";
import Container from "../../common/Container";

import {
  FooterSection,
  NavLink,
  Extra,
  Para,
  FooterContainer,
  Language,
  SocialIconsContainer,
} from "./styles";
import styled from "styled-components";
import { FaInstagram, FaLinkedin, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";


const Footer = ({ t }: { t: TFunction }) => {
  const branches = [
    { city: "Trivandrum", state: "Kerala" },
    { city: "Kochi", state: "Kerala" },
    { city: "Bangalore", state: "Karnataka" },
    { city: "Mangaluru", state: "Karnataka" },
    { city: "Mysore", state: "Karnataka" },
    { city: "Chennai", state: "Tamil Nadu" },
  ];

  return (
    <FooterSection>
      <Container>
        <FooterGrid>
          {/* About Section */}
          <FooterColumn>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <FooterLogo>
                <img src="/img/learnoza-01.png" alt="Learnoza Logo" style={{ width: '180px', height: 'auto', objectFit: 'contain' }} />
              </FooterLogo>
              <Para>
                Learnoza Edu Consultancy - Your trusted partner for educational guidance.
                We help students achieve their academic dreams with personalized counseling
                and expert support.
              </Para>
              <SocialIconsContainer>
                <a href="https://www.instagram.com/learnoza.in/" target="_blank" rel="noreferrer">
                  {/* @ts-ignore */}
                  <FaInstagram />
                </a>
                <a href="https://www.linkedin.com/company/learnoza" target="_blank" rel="noreferrer">
                  {/* @ts-ignore */}
                  <FaLinkedin />
                </a>
                <a href="https://wa.me/919207303585" target="_blank" rel="noreferrer">
                  {/* @ts-ignore */}
                  <FaWhatsapp />
                </a>
              </SocialIconsContainer>
            </motion.div>
          </FooterColumn>

          {/* Quick Links */}
          <FooterColumn>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <Language>Quick Links</Language>
              <FooterLinks>
                <NavLink to="/">Home</NavLink>
                <NavLink to="/courses">Courses</NavLink>
                <NavLink to="/services">Services</NavLink>
                <NavLink to="/about">About Us</NavLink>
              </FooterLinks>
            </motion.div>
          </FooterColumn>

          {/* Our Branches */}
          <FooterColumn>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Language>Our Branches</Language>
              <BranchesGrid>
                {branches.map((branch, index) => (
                  <BranchItem key={index}>
                    {/* @ts-ignore */}
                    <FaMapMarkerAlt />
                    <span>{branch.city}</span>
                  </BranchItem>
                ))}
              </BranchesGrid>
            </motion.div>
          </FooterColumn>

          {/* Contact Info */}
          <FooterColumn>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <Language>Contact Us</Language>
              <ContactCard>
                <ContactItem>
                  {/* @ts-ignore */}
                  <ContactIcon><FaPhone /></ContactIcon>
                  <ContactText>
                    <a href="tel:+919207303585">+91 92073 03585</a>
                  </ContactText>
                </ContactItem>
                <ContactItem>
                  {/* @ts-ignore */}
                  <ContactIcon><FaEnvelope /></ContactIcon>
                  <ContactText>
                    <a href="mailto:learnoza@gmail.com">learnoza@gmail.com</a>
                  </ContactText>
                </ContactItem>
                <ContactItem>
                  {/* @ts-ignore */}
                  <ContactIcon><FaWhatsapp /></ContactIcon>
                  <ContactText>
                    <a href="https://wa.me/919207303585" target="_blank" rel="noreferrer">
                      WhatsApp Us
                    </a>
                  </ContactText>
                </ContactItem>
              </ContactCard>

              {/* Head Office Map */}
              <MapContainer>
                <MapLabel>Head Office - Trivandrum</MapLabel>
                <iframe
                  title="Google Map"
                  width="100%"
                  height="120"
                  frameBorder="0"
                  scrolling="no"
                  style={{ border: "0", borderRadius: "12px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.014552462636!2d76.7833614!3d8.8000067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDgnMDAuMCJOIDc2wrA0NycwMC4xIkU!5e0!3m2!1sen!2sin!4v1700000000000"
                  allowFullScreen
                ></iframe>
              </MapContainer>
            </motion.div>
          </FooterColumn>
        </FooterGrid>
      </Container>

      {/* Footer Bottom Section */}
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "1rem" }}
          >
            <NavLink to="/">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <img src="/img/learnoza-01.png" alt="Learnoza Logo" style={{ width: '140px', height: 'auto', objectFit: 'contain' }} />
              </motion.div>
            </NavLink>
            <FooterContainer>
              © {new Date().getFullYear()} Learnoza Edu Consultancy. All rights reserved.
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </FooterSection>
  );
};

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
  gap: 3rem;
  padding: 2rem 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const FooterColumn = styled.div``;

const FooterLogo = styled.div`
  margin-bottom: 1rem;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const BranchesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
`;

const BranchItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #555;
  transition: all 0.3s ease;

  svg {
    color: #FEC409;
    font-size: 0.8rem;
  }

  &:hover {
    color: #267A8D;
    transform: translateX(3px);
  }
`;

const ContactCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const ContactIcon = styled.div`
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, rgba(38, 122, 141, 0.1) 0%, rgba(254, 196, 9, 0.1) 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #267A8D;
    font-size: 1rem;
  }
`;

const ContactText = styled.div`
  a {
    color: #555;
    font-size: 0.95rem;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #267A8D;
    }
  }
`;

const MapContainer = styled.div`
  margin-top: 1rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
`;

const MapLabel = styled.div`
  font-size: 0.8rem;
  color: #267A8D;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export default withTranslation()(Footer);
